var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.547 0H3.952L0 3.953v5.594L3.953 13.5h5.594L13.5 9.547V3.952L9.547 0zM6.75 10.725a.973.973 0 01-.975-.975c0-.54.435-.975.975-.975s.975.435.975.975-.435.975-.975.975zM7.5 7.5H6V3h1.5v4.5z",
    fill: "#B00020"
  })));
}
export default __webpack_public_path__ + "img/5d62ff97ecf3d504df0264c4f5ef31c6.svg";
export { SvgWarningIcon as ReactComponent };